<div mat-dialog-title *ngIf="showHeader"></div>
<div mat-dialog-content class="m-0 mt-3">

  @if(title!==""){
  <h2 class="{{isErrorMessage ? 'text-danger' : 'ap-blue'}}">{{ title | translate }}</h2>
  }

  <span [innerHTML]="data.message | translate"></span>
  <div *ngIf="data.subMessages">
    @for(msg of data.subMessages; track msg){
    <span>{{msg | translate}}</span>
    }
  </div>
</div>
<div mat-dialog-actions class="row m-0 p-2 justify-content-end">
  <ng-container [ngSwitch]="btnType">
    <ng-container *ngSwitchCase="btnTypeEnum.YES_NO">
      <div class="col-auto">
        <a href="javascript:void(0);" (click)="onYesClick()" class="ap-green text-decoration-none">{{ 'ml_143931' | translate }}</a>
      </div>
      <div class="col-auto p-0">
        <app-line-separator [width]="LineSeparatorStyle.NORMAL" [color]="ColorTheme.DARK"></app-line-separator>
      </div>
      <div class="col-auto">
        <a href="javascript:void(0);" (click)="onNoClick()" class="ap-green text-decoration-none">{{ 'ml_143932' | translate }}</a>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="btnTypeEnum.OK_CANCEL">
      <div class="col-auto">
        <a href="javascript:void(0);" (click)="onOkClick()" class="ap-green text-decoration-none">{{ 'ml_143934' | translate }}</a>
      </div>
      <div class="col-auto p-0">
        <app-line-separator [width]="LineSeparatorStyle.NORMAL" [color]="ColorTheme.DARK"></app-line-separator>
      </div>
      <div class="col-auto">
        <a href="javascript:void(0);" (click)="onCancelClick()" class="ap-green text-decoration-none">{{ 'ml_143935' | translate }}</a>
      </div>
    </ng-container>
    <div *ngSwitchDefault class="col-auto align-self-end">
      <button class="button--default" [mat-dialog-close]="true">{{ 'ml_143929' | translate}}</button>
    </div>
  </ng-container>
</div>
